@if(topicsStatus(); as topicsStatus) {
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Topic</th>
		<th>Total Events</th>
		<th>Missing Specialists</th>
	</tr>
	@for(topic of topicsStatus; track topic.topicId) {
	<tr>
		<td>{{topic.topicName}}</td>
		<td>{{topic.eventsCount}}</td>
		<td>{{topic.missingSpecialistsCount}}</td>
	</tr>
	}
</table>
}